import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';

export const FORM_POPUP_SMALL_BREAKPOINT = COMMON_MOBILE_BREAKPOINT;
export const FORM_POPUP_MEDIUM_BREAKPOINT = 580;
